<template>
    <div>
        <h3 class="welcome">Welcome to the admin portal</h3> <br>
        Please enter your access code to proceed.
        <br>

        <input type="text" id="access-code" hint="enter access code"><br>
        <button v-on:click="codeEntered()" class="success-btn">Submit</button>

        
    </div>
</template>


<script>
export default {
    name: 'Admin',
    methods: {
        codeEntered: function() {
            alert("code entered is " + document.getElementById('access-code').value);
        }
    }
}
</script>


<style scoped>
    .welcome {
        padding-top: 80px;
    }

    #access-code {
        margin-top: 40px;
        margin-bottom: 20px;
    }

    .success-btn {
        margin-bottom: 80px;
    }

</style>
